// utils/decryptTransform.js
import { createTransform } from 'redux-persist';
import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.SECRET_KEY || 'hydrokey';

/**
 * Transform khusus untuk decrypt data yang diencrypt oleh encryptTransform
 * Hanya melakukan decrypt pada outbound (storage → state)
 */
export const decryptTransform = createTransform(
  // inbound: state → storage (tidak melakukan apa-apa, biarkan proses encrypt biasa)
  (inboundState, key) => {
    // Return as-is, biarkan encryptTransform yang handle encryption
    return inboundState;
  },

  // outbound: storage → state (decrypt data yang diencrypt oleh encryptTransform)
  (outboundState, key) => {
    try {
      // Hanya decrypt jika data adalah string (kemungkinan terenkripsi)
      if (typeof outboundState === 'string') {
        const bytes = CryptoJS.AES.decrypt(outboundState, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // Jika berhasil decrypt, parse sebagai JSON
        if (decrypted) {
          return JSON.parse(decrypted);
        }

        // Jika decrypt menghasilkan string kosong, return null
        return null;
      }

      // Jika bukan string, return as-is (data tidak terenkripsi)
      return outboundState;
    } catch (error) {
      console.error('Decryption error:', error);

      // Fallback: coba parse sebagai JSON biasa jika decrypt gagal
      try {
        return typeof outboundState === 'string'
          ? JSON.parse(outboundState)
          : outboundState;
      } catch {
        return outboundState;
      }
    }
  }
);

export default decryptTransform;
